import React from "react";
import "../Navbar/Navbar.css";
import { FaFacebookF } from "react-icons/fa";
import { FaBars } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { FaXmark } from "react-icons/fa6";
import { useLocation } from "react-router-dom";
import { FaInstagram, FaYoutube, FaTwitter, FaWhatsapp } from "react-icons/fa";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

const Navbar = () => {
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleMenuToggle = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleNavigation = (path) => {
    navigate(path);
    setIsMenuOpen(false);
  };

  const location = useLocation(); // Add this to get current path
  // Function to check if a route is active
  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <>
      {/* Top Contact Bar */}
      <div className="container-fluid pt-2 pb-2 bg-dark text-white d-none d-md-block">
        <div className="row align-items-center  text-md-start ">
          <div className="col-12 col-md-7 d-flex  justify-content-start gap-3  mt-2 mt-md-0 text-white">
            <span className=" d-flex align-items-center gap-2" style={{fontSize:"14px"}}>
              <i className="bi bi-telephone me-0 fs-6" style={{color:"#008cff"}}></i><a href="tel:+91 9600480052" className="text-decoration-none text-white">+91 9600 4800 52</a>
            </span>
            <span className=" d-flex align-items-center gap-2 " style={{fontSize:"14px"}}>
              <i className="bi bi-envelope  me-0 fs-6"  style={{color:"#008cff"}}></i>{" "}
             <a href="mailto:hr@berlintechnovation.com" className="text-decoration-none text-white"> hr@berlintechnovation.com</a>
            </span>
          </div>
          <div className="col-12 col-md-5 d-flex justify-content-md-end gap-3">
            {/* Facebook */}
            <a href="#" className="icons " style={{ color: "#ffffff" }}>
              <FaFacebookF size={18} />
            </a>

            {/* Instagram */}
            <a href="#" className="icons" style={{ color: "#ffffff" }}>
              <FaInstagram size={18} />
            </a>

            {/* YouTube */}
            <a href="#" className="icons" style={{ color: "#ffffff" }}>
              <FaYoutube size={18} />
            </a>

            {/* X (Twitter) */}
            <a href="#" className="icons" style={{ color: "#ffffff" }}>
              <FaTwitter size={18} />
            </a>

            {/* WhatsApp */}
            <a
              href="https://wa.me/919600480052"
              target="_blank"
              rel="noopener noreferrer"
              className="rounded-circle shadow"
              style={{ color: "#ffffff" }}
            >
              <FaWhatsapp size={20} />
            </a>
          </div>
        </div>
      </div>

      {/* Main Navigation */}
      <nav className="main-navbar bg-white">
        <div className="container">
          <div className="navbar-container">
            {/* Logo */}
            <div
              className="navbar-brand"
              onClick={() => {
                navigate("/");
                window.scrollTo({ top: 0, behavior: "smooth" });
              }}
              style={{ cursor: "pointer" }}
            >
              <img
                src={require("../Img/images/Logo - New.png")}
                alt="Berlin Technovation"
                className="logo"
                style={{height:"50px",objectFit:"cover"}}
              />
            </div>

            {/* Desktop Menu */}
            <div className="navbar-menu d-none d-lg-flex">
              <ul className="nav-list">
                <li className="nav-item">
                  <a
                    onClick={() => {
                      navigate("/");
                      window.scrollTo({ top: 0, behavior: "smooth" });
                    }}
                    className={`nav-link ${isActive("/") ? "active" : ""}`}
                  >
                    Home
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    onClick={() => {
                      navigate("/Aboutus");
                      window.scrollTo({ top: 0, behavior: "smooth" });
                    }}
                    className={`nav-link ${
                      isActive("/Aboutus") ? "active" : ""
                    }`}
                  >
                    About Us
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    onClick={() => {
                      navigate("/Courses");
                      window.scrollTo({ top: 0, behavior: "smooth" });
                    }}
                    className={`nav-link ${
                      isActive("/Courses") ? "active" : ""
                    }`}
                  >
                    Courses
                  </a>
                </li>

                <li className="nav-item">
                  <a
                    onClick={() => {
                      navigate("/Placement");
                      window.scrollTo({ top: 0, behavior: "smooth" });
                    }}
                    className={`nav-link ${
                      isActive("/Placement") ? "active" : ""
                    }`}
                  >
                    Placements
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    onClick={() => {
                      navigate("/Internship");
                      window.scrollTo({ top: 0, behavior: "smooth" });
                    }}
                    className={`nav-link ${
                      isActive("/Internship") ? "active" : ""
                    }`}
                  >
                    Internship
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    onClick={() => {
                      navigate("/Contactus");
                      window.scrollTo({ top: 0, behavior: "smooth" });
                    }}
                    className={`nav-link ${
                      isActive("/Contactus") ? "active" : ""
                    }`}
                  >
                    Contact Us
                  </a>
                </li>
              </ul>
            </div>

            {/* CTA Button */}
            <div className="navbar-cta d-none d-lg-block">
              <button className="cta-button" onClick={() => setShowModal(true)}>
                <span>Get Started</span>
                <div className="button-overlay"></div>
              </button>
            </div>

            {/* Mobile Menu Toggle */}
            <div
              className="mobile-menu-toggle d-lg-none"
              style={{ height: "fit-content" }}
            >
              <button
                className="menu-toggle-btn"
                onClick={handleMenuToggle}
                aria-label="Toggle Menu"
              >
                {isMenuOpen ? <FaXmark /> : <FaBars />}
              </button>
            </div>
          </div>

          {/* Mobile Menu */}
          <div
            className={`mobile-menu d-lg-none ${isMenuOpen ? "active" : ""}`}
          >
            <ul className="mobile-nav-list">
              <li>
                <a
                  onClick={() => {handleNavigation("/");
                    window.scrollTo({top:0,behavior:"smooth"})
                  }}
                  
                  className="mobile-nav-link"
                >
                  Home
                </a>
              </li>
              <li>
                <a
                  onClick={()=>{handleNavigation("/Aboutus");
                    window.scrollTo({top:0,behavior:"smooth"})
                  }}
                  className="mobile-nav-link"
                >
                  About Us
                </a>
              </li>
              <li>
                <a
                 
                  onClick={()=>{handleNavigation("/Courses");
                    window.scrollTo({top:0,behavior:"smooth"})
                  }}
                  className="mobile-nav-link"
                >
                  Courses
                </a>
              </li>

              <li>
                <a
                
                  onClick={()=>{handleNavigation("/Placement");
                    window.scrollTo({top:0,behavior:"smooth"})
                  }}
                  className="mobile-nav-link"
                >
                  Placements
                </a>
              </li>
              <li>
                <a
                  // onClick={() => handleNavigation("/Internship")}
                  onClick={()=>{handleNavigation("/Internship");
                    window.scrollTo({top:0,behavior:"smooth"})
                  }}
                  className="mobile-nav-link"
                >
                  Internship
                </a>
              </li>
              <li>
                <a
                  // onClick={() => handleNavigation("/Contactus")}
                  onClick={()=>{handleNavigation("/Contactus");
                    window.scrollTo({top:0,behavior:"smooth"})
                  }}
                  className="mobile-nav-link"
                >
                  Contact Us
                </a>
              </li>
              <li className="mobile-cta">
                <button
                  className="mobile-cta-button"
                  onClick={() => setShowModal(true)}
                >
                  Get Started
                </button>
              </li>
            </ul>
          </div>
        </div>
      </nav>

      {/* Enhanced Modal */}
      {showModal && (
        <div
          className="custom-modal-overlay"
          onClick={() => setShowModal(false)}
        >
          <div className="custom-modal" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header-custom">
              <h3 className="modal-title-custom">Join Our Community</h3>
              <button
                className="modal-close-btn"
                onClick={() => setShowModal(false)}
                aria-label="Close"
              >
                <FaXmark />
              </button>
            </div>
            <div className="modal-body-custom">
              <form className="modal-form">
                <div className="form-group">
                  <input
                    type="text"
                    className="form-input"
                    placeholder="Full Name"
                    required
                  />
                </div>
                <div className="form-group">
                  <input
                    type="email"
                    className="form-input"
                    placeholder="Email Address"
                    required
                  />
                </div>
                <div className="form-group">
                  <input
                    type="tel"
                    className="form-input"
                    placeholder="Mobile Number"
                    required
                  />
                </div>
                <div className="form-group">
                  <select
                    className="form-select text-muted"
                    defaultValue="" // React will select the empty value by default
                    aria-label="Choose preferred Courses"
                  >
                    <option value="" disabled hidden>
                      Select your preferred Courses
                    </option>
                    <option>Cybersecurity</option>
                    <option>Data Analytics</option>
                    <option>Oracle SQL</option>
                    <option>Power BI</option>
                    <option>Python</option>
                    <option>Software Testing</option>
                    <option>Tableau</option>
                  </select>
                </div>

                <button type="submit" className="form-submit-btn">
                  <span>Submit</span>
                  {/* <div className="btn-shimmer"></div> */}
                </button>
              </form>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Navbar;
